<template>
  <div>
    <div class="page flex-col">
      <div class="box_1 flex-col">
        <!-- 头部导航组件 -->
        <HeaderNav />

        <!-- 统一的顶部装饰和图片 -->
        <div class="box_1-spacer flex-col"></div>
        <div class="box_2 flex-col"></div>
        <img class="image_1" referrerpolicy="no-referrer" :src="getImageUrl(siteConfig?.config?.['pic_服务项目']) || '/files/images/M3.jpg'" />

        <!-- 服务项目内容 -->
        <div class="news-content flex-col">
          <div class="news-header flex-col">
            <h1 class="news-title">服务项目</h1>
            <p class="news-subtitle">SERVICE PROJECTS</p>
          </div>
          
          <div class="news-list flex-col" v-if="projectList.length > 0">
            <div 
              v-for="project in projectList" 
              :key="project.id"
              class="news-item flex-row"
            >
              <div class="news-content-wrapper flex-col">
                <h3 class="news-item-title">{{ project.title }}</h3>
                <div class="news-item-desc" v-html="removeImagesFromHtml(project.content)"></div>
              </div>
            </div>
          </div>

          <div class="news-empty flex-col" v-if="!loading && projectList.length === 0">
            <p>暂无服务项目</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>

<script>
 import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getProjects } from '@/api/home';
import { getImageUrl } from '@/config/api';
import { getSiteConfig } from '@/store/siteConfig';
import { Toast } from 'vant';

export default {
  name: 'Service',
  components: {
     HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      projectList: [],
      loading: false
    };
  },
  computed: {
    siteConfig() {
      return getSiteConfig();
    }
  },
  created() {
    this.fetchProjects();
  },
  methods: {
    // 获取服务项目列表
    async fetchProjects() {
      this.loading = true;
      try {
        const res = await getProjects();
        if (res.code === 0 && res.data && res.data.list) {
          this.projectList = res.data.list;
        } else {
          Toast.fail(res.msg || '获取服务项目失败');
        }
      } catch (error) {
        console.error('获取服务项目失败:', error);
        Toast.fail('获取服务项目失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    },
    // 移除 HTML 中的图片标签
    removeImagesFromHtml(html) {
      if (!html) return '';
      // 使用正则表达式移除所有 <img> 标签及其内容
      return html.replace(/<img[^>]*>/gi, '');
    }
  }
};
</script>

<style scoped>
/* 页面容器 - 自适应 */
.page {
  position: relative !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100vh !important;
  margin: 0 auto !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  box-sizing: border-box !important;
}

/* 主容器 - 自适应 */
.box_1 {
  background-color: rgba(255, 255, 255, 1) !important;
  position: relative !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100vh !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

/* 统一的顶部装饰和图片样式 - 自适应 */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.image_1 {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* 新闻内容区域 - 自适应 */
.news-content {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 42px auto 0 !important;
  padding: 40px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.news-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 50px !important;
  padding-bottom: 30px !important;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2) !important;
  box-sizing: border-box !important;
}

.news-title {
  width: auto !important;
  height: auto !important;
  font-size: clamp(28px, 4vw, 36px) !important; /* 响应式字体 */
  font-weight: bold !important;
  color: rgba(0, 149, 151, 1) !important;
  margin: 0 0 10px 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

.news-subtitle {
  width: auto !important;
  height: auto !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体 */
  color: #666 !important;
  margin: 0 !important;
  text-align: center !important;
  letter-spacing: 2px !important;
  line-height: 1.2 !important;
}

.news-list {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 30px !important;
  box-sizing: border-box !important;
}

.news-item {
  width: 100% !important;
  padding: 30px !important;
  border: 1px solid rgba(0, 149, 151, 0.1) !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: all 0.3s !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  box-sizing: border-box !important;
  gap: 20px !important;
}

.news-item:hover {
  border-color: rgba(0, 149, 151, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 149, 151, 0.1) !important;
  transform: translateY(-2px) !important;
}

.news-content-wrapper {
  flex: 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  box-sizing: border-box !important;
}

.news-item-title {
  width: 100% !important;
  height: auto !important;
  font-size: clamp(18px, 2.5vw, 20px) !important; /* 响应式字体 */
  font-weight: 500 !important;
  color: #333 !important;
  margin: 0 0 15px 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  line-height: 1.4 !important;
}

.news-item-desc {
  width: 100% !important;
  height: auto !important;
  font-size: clamp(14px, 1.8vw, 16px) !important; /* 响应式字体 */
  color: #666 !important;
  line-height: 1.6 !important;
  margin: 0 !important;
  /* 展示完整内容，不做行数裁剪 */
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
}

.news-empty {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 100px 20px !important;
  color: #999 !important;
  font-size: clamp(14px, 1.8vw, 16px) !important; /* 响应式字体 */
  box-sizing: border-box !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .image_1 {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .news-content {
    padding: 30px 15px !important;
    margin: 30px auto 0 !important;
  }

  .news-header {
    margin-bottom: 30px !important;
    padding-bottom: 20px !important;
  }

  .news-list {
    gap: 20px !important;
  }

  .news-item {
    padding: 20px !important;
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .news-item-title {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
  }
}
</style>
